import { ChangeEvent, ComponentPropsWithRef, FocusEvent } from 'react';
import { Controller } from 'react-hook-form';

import { InputAutoCompletePatientField } from '../input/input-auto-complete-patient-field';

type InputAutoCompleteFieldPatientControllerProps = Omit<
  ComponentPropsWithRef<typeof InputAutoCompletePatientField>,
  'name' | 'defaultValue' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: string;
  onChange?: (value: string, e: ChangeEvent<HTMLElement>) => void;
  onBlur?: (value: string, e: FocusEvent<HTMLElement>) => void;
};

export function InputAutoCompletePatientFieldController(
  props: InputAutoCompleteFieldPatientControllerProps
) {
  const { defaultValue, onChange, onBlur, ...defaultProps } = props;

  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <InputAutoCompletePatientField
          {...defaultProps}
          onChange={(val, e) => {
            onControllerChange(val);

            onChange?.(val, e);
          }}
          onBlur={(val, e) => {
            onControllerChange(val);

            onControllerBlur();

            onBlur?.(val, e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={props.name}
      defaultValue={defaultValue ?? ''}
    />
  );
}
